// Canonical legal URLs (BRK-S149).
//
// The privacy policy is ONE document for the whole entity — it describes the
// controller's data practices, not a website's — and it lives on the marketing
// site (Aaron, 2026-09-09). This portal LINKS to it and never restates it: two
// copies of one policy diverge, and the divergence is what an evidence review
// finds. Kept here rather than inline so the page and the footer point at the
// same string, and so a move is a one-line change.

/** The entity-wide privacy policy. Owned by the `www` repo (WWW-S053). */
export const PRIVACY_POLICY_URL = "https://www.signalspecialty.com/privacy/";

/** The marketing site's own terms — a different bargain (anonymous browsing of
 *  an informational site), referenced so a reader can find them. */
export const MARKETING_TERMS_URL = "https://www.signalspecialty.com/terms/";

/** Attributes every off-origin legal link carries: a new context, opened
 *  safely. */
export const EXTERNAL_LINK_PROPS = {
  target: "_blank",
  rel: "noopener noreferrer",
} as const;
